import React from 'react';
import { ArticleSection } from './ArticleSection';
import { site } from '../../data/site';
const layers = [{
  name: 'Orchestration',
  text: 'the workflow engine that sequences steps, handles retries and keeps track of state.'
}, {
  name: 'Intelligence',
  text: 'language models, classifiers and retrieval systems that interpret content and suggest actions.'
}, {
  name: 'Control',
  text: 'human approval points, permissions, monitoring and logs that keep the process accountable.'
}];
export function WhatIsSection() {
  return <ArticleSection id="what-is" title="What Is AI Workflow Automation?" data-id="element-141" data-mp="10xbw4cxlxw4y">
      <p data-id="element-142" data-mp="w0v77gil3dqt">
        AI workflow automation combines traditional process automation (triggers, rules, integrations and
        scheduled jobs) with AI models that can read, classify, summarise, draft and decide. Classic
        automation is excellent at moving structured data from one system to another. It struggles the
        moment work involves an unstructured email, a scanned invoice, an ambiguous customer request or a
        judgement call.
      </p>
      <p data-id="element-143" data-mp="26r72e6x463t4">
        That is where AI changes the equation. A modern workflow might receive a supplier email, extract
        the invoice details with a language model, check them against a purchase order in the ERP, route
        any mismatch to a finance lead for approval and post the approved entry to the accounting system,
        logging every step for audit.
      </p>

      <figure className="!mt-8 overflow-hidden rounded-2xl border border-line" data-id="element-144" data-mp="2kjdg7mcsnype">
        <img src={site.ogImage} alt={site.ogImageAlt} width={1376} height={768} loading="lazy" decoding="async" className="h-auto w-full" data-id="element-145" data-mp="2ph6nyjtqx0rs" />
        <figcaption className="bg-night-800 px-5 py-3 text-sm text-faint" data-id="element-146" data-mp="2fpsi7ub7b4q7">
          A typical AI workflow: unstructured inputs are interpreted, checked, approved and completed across connected systems.
        </figcaption>
      </figure>

      <p data-id="element-147" data-mp="3i4oj59q1cf2v">Three layers usually make it work:</p>
      <dl className="!mt-6 grid gap-px overflow-hidden rounded-2xl border border-line bg-line sm:grid-cols-3" data-id="element-148" data-mp="3i3mxycfb2c7f">
        {layers.map(layer => <div key={layer.name} className="bg-night-900 p-5" data-id="element-149" data-mp="39388d0vb6ay4">
            <dt className="font-display text-xl text-ink" data-id="element-150" data-mp="395kza3j1nvnb">{layer.name}</dt>
            <dd className="mt-2 text-[0.95rem] leading-7 text-muted" data-id="element-151" data-mp="343lv4rfhcupb">{layer.text}</dd>
          </div>)}
      </dl>
      <p data-id="element-152" data-mp="2z6lr0m26y20u">
        Good providers design all three together. Weak ones bolt a chatbot onto an unchanged process and
        call it transformation.
      </p>
    </ArticleSection>;
}